'use client';

import { useEffect, useState } from 'react';

import Link from 'next/link';

import { ArrowRightIcon } from 'lucide-react';

export function StickyMobileCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`site-sticky-cta bg-background/95 border-border fixed bottom-0 left-0 z-50 w-full border-t p-3 backdrop-blur-md transition-transform duration-300 lg:hidden ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <Link
        href="/contact"
        className="bg-primary text-primary-foreground flex w-full items-center justify-center gap-2 rounded-lg px-4 py-3 text-sm font-medium transition-colors hover:opacity-90"
      >
        Book a Free Consultation
        <ArrowRightIcon className="h-4 w-4" />
      </Link>
    </div>
  );
}
